import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { GlobalWrapper } from './reset.style';
import { useAppStateContext } from 'src/appState/AppState';
import { RollingDepositLimitPopup } from 'src/domains/players/webview/components/RollingDepositLimitPopup';
import { Overlay } from 'src/domains/layouts/webview/components/overlay/Overlay';
import { QuickBet } from 'src/domains/sportsbook/betting/ui/betSlip/quickBet/QuickBet';
import { HomePageLayout as HomePage } from 'src/domains/layouts/layouts/homepage/Homepage';
import { EventLayout as EventPage } from 'src/domains/sportsbook/webview/layouts/eventPage/EventPage';
import { CompetitionPage } from 'src/domains/sportsbook/webview/layouts/competitionPage/CompetitionPage';
import { InPlayLayout as InPlayPage } from 'src/domains/sportsbook/webview/layouts/inPlayPage/InPlayPage';
import { CasinoPage } from 'src/domains/casino/webview/layouts/casinoPage/CasinoPage';
import { SearchPage as Search } from 'src/domains/layouts/layouts/seachPage/SearchPage';
import { NavigationSports } from 'src/domains/layouts/layouts/navigationSportsPage/NavigationSportsPage';
import { Notifications } from 'src/domains/layouts/webview/components/notificationsPage/NotificationsPage';
import { PopupContainer } from 'src/domains/layouts/webview/components/popups/PopupContainer';
import { AppWrapper } from './ui.style';
import { MarketingNotificationsBanner } from 'src/domains/layouts/webview/components/marketingNotificationsBanner/MarketingNotificationsBanner';
import { LiveCasinoPage } from 'src/domains/casino/webview/layouts/liveCasinoPage/LiveCasinoPage';
import { RacingStreamGlobal } from 'src/domains/sportsbook/webview/components/stream/RacingStreamGlobal';
import { AccountSidebar } from 'src/domains/players/webview/components/Account';
import { Banners } from 'src/domains/layouts/webview/components/banners/Banners';
import { DebugPanel } from 'src/domains/layouts/webview/components/debugPanel/DebugPanel';
import { MiniGames, VirtualsPage } from 'src/domains/casino/shared/Components';
import { NoConnection } from 'src/domains/layouts/layouts/utilityPages/errorPage/NoConnection';
import { CookiesPolicyBox } from 'src/domains/layouts/webview/components/cookiesPolicyBox/CookiesPolicyBox';
import { SpecialSportPage } from 'src/domains/layouts/layouts/specialSportPage/SpecialSportPage';
import { SportPage } from 'src/domains/layouts/layouts/sportPage/SportPage';
import { RaceCardPage } from 'src/domains/sportsbook/webview/layouts/raceCardPage/RaceCardPage';
import { SrgQuestionnaire } from 'src/domains/players/state/srgQuestionnaire/srgQuestionnaire/SrgQuestionnaire';
import { PromotedEvents } from 'src/domains/layouts/layouts/promotedEvents/PromotedEvents';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { BannersContainer } from 'src/domains/layouts/webview/components/BannerBox/BannersContainer';
import { TraderChatButtonFloating } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/traderChatLinkNav/TraderChatLinkNav';
import { FreshDeskIframe } from 'src/domains/layouts/webview/components/freshDesk/FreshDeskIframe';
import { DepositLimitUpdatePopup } from 'src/domains/players/state/accountState/DepositLimitsUpdatePopups/DepositLimitUpdatePopup/DepositLimitUpdatePopup';
import { PofPopups } from 'src/domains/players/webview/components/PofPopups';
import { PageNotFoundFallBackLoader } from 'src/domains/layouts/layouts/utilityPages/errorPage/PageNotFound';
import { Footer } from 'src/domains/layouts/webview/modules/layoutSkeleton/Footer';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { FeatureState } from 'src/domains/layouts/config/features/featureState/FeatureState';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { TraderChatState } from 'src/domains/players/state/traderChat/TraderChatState';
import { MonthlyActivityPopup } from 'src/domains/layouts/webview/components/popups/monthlyActivityPopup/monthlyActivityPopup';
import { BlockingNotifications } from 'src/domains/players/webview/components/Account/Notifications/BlockingNotifications';
import { IntercomChat } from 'src/domains/layouts/webview/components/IntercomChat';
import { useEffect } from 'react';
import { SymplifyState } from 'src/domains/layouts/state/symplify/SymplifyState';
import { BonusEnginePopup } from 'src/domains/layouts/webview/components/popups/bonusEnginePopup/BonusEnginePopup';
import { BetslipBonusPopup } from 'src/domains/sportsbook/betting/ui/betSlip/betslipBonus/BetslipBonusPopup';
import { GamblingSafetyTopBar } from 'src/domains/layouts/webview/components/gamblingSafetyTopBar/GamblingSafetyTopBar';
import { IdMission } from 'src/domains/players/state/IdMission/IdMissionPopup/IdMissionPopup';
import { StaticPageContent } from 'src/domains/players/webview/components/Account/Notifications/StaticPageContent';
import { DownloadAppBanner } from 'src/domains/layouts/webview/components/downloadAppBanner';
import { useCookiebot, useDevice } from 'src/domains/common/hooks';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ssrReactLazy } from 'src_common/common/mobx-utils/ResourceSSR';
import {
    BlockingNotificationType,
    NonBlockingNotificationType,
} from 'src_server/trpc/types/accountModel/accountResponse';
import { NonBlockingNotifications } from 'src/domains/players/webview/components/Account/Notifications/NonBlockingNotifications';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { SdkCustomer } from 'src/domains/layouts/state/customer';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';
import { UsersState } from 'src/domains/players/state/UsersState';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';
import { streamButtonBarDesktop } from 'src/domains/sportsbook/shared/Components';
import { headerHeight } from './ui.style';

//TODO - try to split this file into smaller files

const PageNotFound = ssrReactLazy(
    async () => (await import('src/domains/layouts/layouts/utilityPages/errorPage/PageNotFound')).PageNotFound
);

interface LayoutType {
    content: JSX.Element;
    footer: JSX.Element | null;
    aside: JSX.Element | null;
}

const DragonBetOptimoveHost = observer('DragonBetOptimoveHost', () => {
    const common = useCommon();
    const { streamBoxHeight, isStreamFloating } = StreamingState.get(common);
    const { bannersBoxState } = AppLayoutsState.get(common);
    const bannersHeight = bannersBoxState.boxHeight;
    const isDesktop = BreakpointsState.get(common).desktop.isBiggerOrEq === true;
    const env = EnvironmentState.get(common);

    if (!common.features.optimoveInboxCustomised) {
        return null;
    }

    const getOptimoveMobileTopOffset = (): number => {
        const fixedStreamHeight = streamBoxHeight - 1;

        if (streamBoxHeight > 0) {
            if (isStreamFloating) {
                return bannersHeight + headerHeight + 8;
            }

            return bannersHeight + headerHeight + fixedStreamHeight + streamButtonBarDesktop + 8;
        }

        return bannersHeight + headerHeight + 8;
    };

    useEffect(() => {
        const host = document.getElementById('optimove-badge-host-dragonbet');

        if (host === null) {
            return;
        }

        host.style.alignItems = 'center';
        host.style.bottom = '0';
        host.style.display = 'flex';
        host.style.flexDirection = 'column';
        host.style.justifyContent = 'flex-start';
        host.style.minWidth = '52px';
        host.style.overflow = 'visible';
        host.style.position = 'fixed';
        host.style.right = '12px';
        host.style.top = `${getOptimoveMobileTopOffset()}px`;
        host.style.width = '52px';
        host.style.zIndex = `${env.emotionTheme.star.zIndexGlobal.rhsMenu + 1}`;

        if (isDesktop) {
            host.style.bottom = '20px';
            host.style.height = '52px';
            host.style.justifyContent = 'center';
            host.style.right = '20px';
            host.style.top = 'auto';
        } else {
            host.style.bottom = '0';
            host.style.height = '52px';
            host.style.justifyContent = 'flex-start';
            host.style.right = '12px';
            host.style.top = `${getOptimoveMobileTopOffset()}px`;
        }
    }, [bannersHeight, env.emotionTheme.star.zIndexGlobal.rhsMenu, isDesktop, isStreamFloating, streamBoxHeight]);

    return null;
});

const AppInner = observer('AppInner', () => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const appPlayersState = AppPlayersState.get(common);
    const { appSportsBookState } = useAppStateContext();
    const appCasinoState = AppCasinoState.get(common);

    const featureState = FeatureState.get(common);
    const config = ConfigComponents.get(common).config;
    const router = StarRouter.get(common);
    const env = EnvironmentState.get(common);

    const {
        srgQuestionnaire: isSrgQuestionnaire,
        traderChat,
        freshDeskChat,
        rollingNetDepositLimit,
        intercomChat,
        bonusEngine,
        isSaferGambling,
        appDownloadLink,
        componentVariants: { sportsbookVariant },
    } = config;

    const { blockingNotificationsState, nonBlockingNotificationsState } = appPlayersState;
    const usersState = UsersState.get(common);
    const isMobileApp = env.isMobileApp();

    const cookiebot = useCookiebot();
    const device = useDevice();

    const getMainId = (): string | undefined => {
        return 'app-wrapper';
    };

    const isMarketingNotificationsBannerVisible = (): boolean => {
        const { isBannerAvailable } = appPlayersState.marketingNotificationsState;
        return isBannerAvailable;
    };

    const renderMarketingNotificationsBanner = (): JSX.Element | null => {
        if (isMarketingNotificationsBannerVisible()) {
            return <MarketingNotificationsBanner key='marketing-banner' />;
        }
        return null;
    };

    const renderCookieBox = (): JSX.Element | null => {
        if (isMobileApp === false && env.isBrowser) {
            return <CookiesPolicyBox key='cookie-banner' />;
        }

        return null;
    };

    const renderGamblingSafety = (): JSX.Element | null => {
        if (isSaferGambling.available && isSaferGambling.hasTopBar) {
            return <GamblingSafetyTopBar />;
        }

        return null;
    };

    const getDownloadAppLink = (): string | null => {
        if (device === 'Android' && appDownloadLink.googlePlayLink !== null) {
            const prefix = 'market';
            return appDownloadLink.googlePlayLink
                .replace('play.google.com/store/apps/', '')
                .replace('https', prefix)
                .replace('http', prefix);
        }

        if (device === 'iOS' && appDownloadLink.appStoreLink !== null) {
            const prefix = 'itms-apps';
            return appDownloadLink.appStoreLink.replace('https', prefix).replace('http', prefix);
        }

        return null;
    };

    const renderDownloadAppBanner = (): JSX.Element | null => {
        const link = getDownloadAppLink();

        if (isMobileApp === true || appDownloadLink.showBanner === false || link === null) {
            return null;
        }

        return (
            <DownloadAppBanner
                link={link}
                cookiebot={cookiebot}
            />
        );
    };

    const renderBanners = (): JSX.Element => {
        return (
            <Banners>
                {renderDownloadAppBanner()}
                {renderMarketingNotificationsBanner()}
                {renderCookieBox()}
                <BannersContainer />
            </Banners>
        );
    };

    const renderPopups = (): JSX.Element => {
        return <PopupContainer />;
    };

    const renderPopupsWithStartApp = (): JSX.Element => {
        return (
            <>
                {rollingNetDepositLimit === true ? <RollingDepositLimitPopup /> : null}
                {rollingNetDepositLimit === true ? <DepositLimitUpdatePopup /> : null}
                {usersState.isMonthlyActivityPopupOpen === false ? null : <MonthlyActivityPopup />}
                {bonusEngine === true ? <BonusEnginePopup /> : null}
                {appSportsBookState.betSlipState.isBonusPopupOpen &&
                appSportsBookState.betSlipState.basicBetSlipState.channel === 'quickbet' ? (
                    <BetslipBonusPopup />
                ) : null}
            </>
        );
    };

    const renderCasinoMini = (currentView: RouteViewType | null): JSX.Element | null => {
        const common = useCommon();
        const breakpointsState = BreakpointsState.get(common);

        const desktopVersion = breakpointsState.desktop.isBiggerOrEq;
        const isAllowCasinoInIOSWrapper = featureState.allowCasinoInIOSWrapperNew;
        const isCasino = currentView?.name === 'casino';

        const casinoMini =
            config.casinoMiniGames === true && isAllowCasinoInIOSWrapper ? (
                <MiniGames appCasinoState={appCasinoState} />
            ) : null;

        if (desktopVersion === null || desktopVersion === true || isCasino) {
            return null;
        }
        return casinoMini;
    };

    const sdkCustomer = SdkCustomer.get(common);
    const { userId } = sdkCustomer.session;

    const renderLayoutWithSidebar = (content: JSX.Element): LayoutType => {
        const accountView = router.accountView;
        const isSignup = accountView?.account === 'signup';

        const renderFooter =
            sportsbookVariant !== DefaultComponentVariantType.SECONDARY ||
            router.currentView?.name === 'casino' ||
            router.currentView?.name === 'virtuals' ||
            router.currentView?.name === 'live-casino';

        const isNotificationsList =
            router.currentView?.name === 'notifications-list' || accountView?.account === 'terms-and-conditions-promos';

        return {
            content,
            footer: renderFooter ? <Footer currentView={router.currentView} /> : null,
            aside: (
                <AccountSidebar
                    isSignUp={isSignup}
                    currentView={router.currentView}
                    promotionSlug={router.freeParams.promo ?? 'homepage'}
                    isNotificationsList={isNotificationsList}
                />
            ),
        };
    };

    const renderLayout = (): LayoutType | null => {
        const { currentView, accountView } = router;

        const isNotificationsList =
            router.currentView?.name === 'notifications-list' || accountView?.account === 'terms-and-conditions-promos';

        if (currentView !== null) {
            if (currentView.name === 'homepage') {
                return renderLayoutWithSidebar(
                    <HomePage
                        accountView={accountView}
                        currentView={currentView}
                        isSearchActive={true}
                    />
                );
            }

            if (currentView.name === 'sports') {
                return renderLayoutWithSidebar(
                    <HomePage
                        accountView={accountView}
                        currentView={{ name: 'homepage' }}
                        isSearchActive={true}
                    />
                );
            }

            if (currentView.name === 'competition') {
                return renderLayoutWithSidebar(
                    <CompetitionPage
                        currentView={currentView}
                        accountView={accountView}
                        isSearchActive={true}
                    />
                );
            }

            if (currentView.name === 'sport') {
                const { hiddenSportsList } = config;

                if (hiddenSportsList.includes(currentView.id)) {
                    return null;
                }

                return renderLayoutWithSidebar(
                    <SportPage
                        currentView={currentView}
                        accountView={accountView}
                        isSearchActive={true}
                        isAmericanFootball={currentView.id === 'americanfootball'}
                    />
                );
            }

            if (currentView.name === 'event') {
                return renderLayoutWithSidebar(
                    <EventPage
                        accountView={accountView}
                        currentView={currentView}
                        isSearchActive={true}
                        isNotificationsList={isNotificationsList}
                    />
                );
            }

            if (currentView.name === 'racecard') {
                const sport = currentView.sport;

                if (sport === 'horseracing' || sport === 'greyhoundracing') {
                    const racecardBuildIds =
                        currentView.collection === 'race-meetings' ? currentView.racecardBuildIds : [];

                    return renderLayoutWithSidebar(
                        <RaceCardPage
                            sport={sport}
                            currentView={currentView}
                            accountView={accountView}
                            isSearchActive={true}
                            racecardBuildIds={racecardBuildIds}
                            racecardCollection={currentView.collection}
                            racecardSelected={currentView.selected}
                        />
                    );
                } else {
                    return null;
                }
            }

            if (currentView.name === 'virtuals' && featureState.allowCasinoInIOSWrapperNew === true) {
                return renderLayoutWithSidebar(
                    <VirtualsPage
                        appCasinoState={appCasinoState}
                        accountView={accountView}
                        currentView={currentView}
                        isSearchActive={false}
                    />
                );
            }

            if (currentView.name === 'sport-special') {
                return renderLayoutWithSidebar(
                    <SpecialSportPage
                        accountView={accountView}
                        currentView={currentView}
                        isSearchActive={true}
                    />
                );
            }

            if (currentView.name === 'inplay') {
                return renderLayoutWithSidebar(
                    <InPlayPage
                        accountView={accountView}
                        currentView={currentView}
                        isSearchActive={true}
                    />
                );
            }

            if (currentView.name === 'casino') {
                if (featureState.allowCasinoInIOSWrapperNew === false) {
                    return null;
                }

                return renderLayoutWithSidebar(
                    <CasinoPage
                        appCasinoState={appCasinoState}
                        currentView={currentView}
                        accountView={accountView}
                        isSearchActive={false}
                    />
                );
            }

            if (currentView.name === 'live-casino') {
                if (featureState.allowCasinoInIOSWrapperNew === false) {
                    return null;
                }

                return renderLayoutWithSidebar(
                    <LiveCasinoPage
                        appCasinoState={appCasinoState}
                        accountView={accountView}
                        currentView={currentView}
                        isSearchActive={false}
                    />
                );
            }

            if (currentView.name === 'search') {
                return renderLayoutWithSidebar(
                    <Search
                        accountView={accountView}
                        currentView={currentView}
                        isSearchActive={true}
                    />
                );
            }

            if (currentView.name === 'navigation-sports') {
                return renderLayoutWithSidebar(
                    <NavigationSports
                        accountView={accountView}
                        currentView={currentView}
                        isSearchActive={true}
                    />
                );
            }

            if (currentView.name === 'notifications-list') {
                return renderLayoutWithSidebar(
                    <Notifications
                        accountView={accountView}
                        currentView={currentView}
                        isSearchActive={true}
                        isNotificationsList={isNotificationsList}
                    />
                );
            }

            if (currentView.name === 'promoted-events' && config.eventsOnLaterHomePage) {
                return renderLayoutWithSidebar(
                    <PromotedEvents
                        accountView={accountView}
                        currentView={currentView}
                        isSearchActive={true}
                    />
                );
            }
        }

        return null;
    };

    const layout = renderLayout();
    const layoutWithAside = layout?.aside ?? null;

    const overlayOnClick = (): void => {
        //Handler for overlay - to improve in the future
        // console.info('overlay on click');
        appLayoutsState.overlay.toggleMenu();
    };

    const name = router.currentView?.name ?? null;
    const isAnyCasinoPage = name === 'casino' || name === 'virtuals' || name === 'live-casino';
    const isRaceCard = name === 'racecard';
    const currentView = router.currentView;
    const accountView = router.accountView;

    const isNotificationsList =
        router.currentView?.name === 'notifications-list' || accountView?.account === 'terms-and-conditions-promos';

    const { streamBoxHeight, isStreamFloating, isStreamOpen } = StreamingState.get(common);
    const { boxHeight: bannersHeight } = appLayoutsState.bannersBoxState;
    const { shouldOverlayOpen, overlayLevel: overlayIndex } = appLayoutsState.overlay;

    const traderChatState = TraderChatState.get(common);
    const hasIdMission = ConfigComponents.get(common).config.idMission;
    const { pofModals } = ConfigComponents.get(common).config;
    const isAvailableBubbleChatButton = traderChat.isBubbleChatButton && traderChatState.isTraderChatForView;

    const { networkConnectionState } = appLayoutsState;
    const { showOfflineMessage } = networkConnectionState;

    const blockingNotificationType = blockingNotificationsState.getBlockingNotificationType;
    const nonBlockingNotificationType = nonBlockingNotificationsState.getNonBlockingNotificationType;

    const isKycRestrictionWithIdMission =
        hasIdMission && blockingNotificationType === BlockingNotificationType.KYC_DEPOSIT_RESTRICTION;

    if (blockingNotificationType !== null && isKycRestrictionWithIdMission === false) {
        return <BlockingNotifications blockingNotificationType={blockingNotificationType} />;
    }

    if (currentView?.name === 'homepage' && currentView.staticPage !== null) {
        if (currentView.staticPage === 'terms-and-conditions' || currentView.staticPage === 'privacy-policy') {
            return <StaticPageContent id={currentView.staticPage} />;
        }
    }
    return (
        <AppWrapper
            data-track={userId}
            id={getMainId()}
            bannersHeight={bannersHeight}
            streamHeight={streamBoxHeight}
            isStreamFloating={isStreamFloating}
            isLayoutHasAside={layoutWithAside !== null}
        >
            {showOfflineMessage && isMobileApp === false ? <NoConnection /> : null}
            {isStreamOpen ? (
                <RacingStreamGlobal
                    isRaceCard={isRaceCard}
                    isAnyCasinoPage={isAnyCasinoPage}
                    isNotificationsList={isNotificationsList}
                />
            ) : null}
            {renderGamblingSafety()}
            {renderBanners()}
            {layout === null ? (
                <React.Suspense fallback={<PageNotFoundFallBackLoader />}>
                    <PageNotFound
                        accountView={accountView}
                        currentView={currentView}
                    />
                </React.Suspense>
            ) : (
                layout.content
            )}

            {layout === null ? null : layout.footer}
            {layout === null ? null : layout.aside}
            {renderPopupsWithStartApp()}
            <QuickBet />
            {renderPopups()}

            {nonBlockingNotificationType === null ? null : (
                <NonBlockingNotifications nonBlockingNotificationType={NonBlockingNotificationType.REVIEW_ACCOUNT} />
            )}
            {usersState.isSrgModalOpen && isSrgQuestionnaire ? <SrgQuestionnaire /> : null}
            {hasIdMission && appPlayersState.identityState.processIdMission.isOpen === true ? <IdMission /> : null}
            {isAvailableBubbleChatButton ? <TraderChatButtonFloating /> : null}
            {freshDeskChat === null ? null : <FreshDeskIframe />}
            {layout === null ? null : renderCasinoMini(currentView)}
            <Overlay
                isVisible={shouldOverlayOpen}
                onClick={overlayOnClick}
                zIndex={overlayIndex}
            />
            {pofModals ? <PofPopups /> : null}
            {intercomChat === true ? <IntercomChat /> : null}
        </AppWrapper>
    );
});

export const App = observer('App', () => {
    const common = useCommon();

    const starRouter = StarRouter.get(common);
    const { currentView } = starRouter;

    const env = EnvironmentState.get(common);

    useEffect(() => {
        SymplifyState.get(common).initCarmaRoi();
    }, []);

    return (
        <>
            <GlobalWrapper
                theme={env.emotionTheme}
                currentView={currentView}
            />
            <AppInner />
            <DragonBetOptimoveHost />
            <DebugPanel currentView={currentView} />
        </>
    );
});
